//export const BASE_URL = "https://api0.jfmd.ca:10450/";
export const BASE_URL = "https://sch1.planifico.co/";
//export const BASE_URL = "http://localhost:3009/";
//export const BASE_URL = "http://localhost:8080/";
export const PLANIFICO_WEBSERVER_BASE_URL = "https://apica1.planifico.co/";

//@ test query params ?ver=2&bizId=672e6875436a3915286cb254&userId=56731152691a870eb834bc42&sessionId=guidf9a732ad-4262-4f82-9731-e9c5828942c6&lang=fr&fromEpoch=1763960400000&toEpoch=1764565199999&wgId=1749929294613_42_api1_1
//@ CISSS Demo - Med interne
//export const PLANIFICO_WEBSERVER_BASE_URL = "http://localhost:61681/";
//export const PLANIFICO_WEBSERVER_BASE_URL = "http://localhost:92/";
export const IS_DEBUG = false;
